<template>
    <div class="drug-lookup">
        <p class="med mt-4">What medication are you looking for?</p>
        <v-autocomplete outlined validate-on-blur v-model="DrugName" :items="items" :search-input.sync="search_words" cache-items :item-text="getItemTextLabel" item-value="DrugName" :placeholder="DrugName" :rules="rules" :loading="isLoading" auto-select-first persistent-hint placeholder="Start typing to search..." hide-no-data></v-autocomplete>
    </div>
</template>
<script>
import GlicAPI from './GlicAPI.js'
import { debounce } from 'vue-debounce'
export default {
    props: ['value', 'label', 'placeholder', 'rules'],
    data: function() {
        return {
            isLoading: false,
            search_words: null,
            DrugName: this.value,
            items: [],
            dont_search: false
        }
    },
    mounted: function() {

    },
    methods: {
        //emit's an update event so that the parent component can grab the name. 
        updateValue: function(v, emit) {
            this.setDontSearch()
            this.DrugName = v;
            if (emit === true) {
                this.$emit('input', v);
            }
        },
        //gets the value shown in the drop down
        getItemTextLabel: function(item) {
            return item.DrugName;
        },
        //if we just set the DrugName for the v-model we don't want to search again for the same agent.
        setDontSearch: function() {
            var g = this
            g.dont_search = true
            setTimeout(function() {
                g.dont_search = false
            }, 1000)
        },
        setSearchWords: function(words) {
            this.updateValue(words)
        }
    },
    watch: {
        'DrugName': function(v) {
            this.updateValue(v, true);
        },
        'value': function(v) {
            this.dont_search = true
            this.updateValue(v, false);
        },
        'search_words': debounce(function(val) {
            var g = this
            //if we just set the agent code for the v-model we don't want to search again for the same agent.
            if (this.dont_search) {
                return
            }
            if (val == null || val.length < 3) {
                this.isLoading = false
                return
            }

            this.isLoading = true

            // Lazily load input items
            GlicAPI.searchdrug(val).then(function(json) {
                g.setDontSearch()
                g.$set(g, 'items', json[0].data)
                g.isLoading = false
            }).catch(function() {
                g.isLoading = false
            });
        }, 250),
    }
}
</script>
<style>
#app .drug-lookup .v-select.v-text-field input {
    display: block !important;
}
</style>